import en from './en'
import hr from './hr'

export const LOCALES = {
  CROATIAN: 'hr',
  ENGLISH: 'en'
}

export const messages = {
  [LOCALES.CROATIAN]: hr,
  [LOCALES.ENGLISH]: en
}

export const defaultLocale = LOCALES.CROATIAN